<div class="relative">
    <!-- Main Button -->
    <app-button color="bg-secondary text-[#310000]" [label]="page_name" icon="bx bx-plus" (click)="show_menu = !show_menu"></app-button>
    <!-- Dropdown -->
    <div *ngIf="show_menu" class="absolute right-0 mt-2 w-52 bg-white border border-gray-200 rounded-xl shadow-lg z-50">
        <button class="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 transition" (click)="openBulk()">
            <img src="assets/bulk_upload.png" class="w-6 h-6">
            <span class="text-base">Bulk Upload</span>
        </button>
        <div class="h-[1px] bg-gray-200"></div>
        <button class="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 transition" (click)="openSingle()">
            <img src="assets/single_upload.png" class="w-6 h-6">
            <span class="text-base">Single Upload</span>
        </button>
    </div>
</div>